import { useLocation, Navigate, Outlet } from "react-router-dom";
import React from "react";

// ─────────────────────────────────────────────────────────────
//  Auth.jsx — UPDATED for DPR role-based access
//
//  WHAT CHANGED from your original:
//  - Now reads "dpr_role" from sessionStorage (set after HRMS login)
//  - allowedRoles is now an ARRAY (not a single string)
//    so multiple roles can access the same route
//  - token check still uses "access_token" (same as before)
//
//  HOW TO USE in your app router:
//
//  <Route element={<Auth allowedRoles={["super_admin", "admin"]} />}>
//    <Route path="projectmanagement" element={<Mainproject />} />
//  </Route>
//
//  <Route element={<Auth allowedRoles={["super_admin"]} />}>
//    <Route path="companymanagement" element={<MainDivision />} />
//  </Route>
// ─────────────────────────────────────────────────────────────

const Auth = ({ allowedRoles }) => {
  const dpr_role = sessionStorage.getItem("dpr_role");     // e.g. "super_admin", "admin"
  const token    = sessionStorage.getItem("access_token"); // existing HRMS token
  const location = useLocation();

  // not logged in at all → go to login
  if (!token) {
    return <Navigate to="login" state={{ from: location }} replace />;
  }

  // logged in but no DPR role assigned yet
  if (!dpr_role) {
    return <Navigate to="unauthorized" state={{ from: location }} replace />;
  }

  // check if user's DPR role is in the allowed list for this route
  const isAllowed = Array.isArray(allowedRoles)
    ? allowedRoles.includes(dpr_role)
    : dpr_role === allowedRoles; // fallback: still works if string passed

  return isAllowed
    ? <Outlet />
    : <Navigate to="unauthorized" state={{ from: location }} replace />;
};

export default Auth;